import Layout from "@/layout/desktop/Layout.vue"
import { baseline } from "./mobile"
import { proposed } from "./mobile"
import { wizardDetails } from "./mobile"

const authRoutes = [
  { path: "", redirect: "/login" },
  {
    path: "/login",
    name: "desktopLogin",
    component: () => import("../views/desktop/auth/Login.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/mobile/auth/Register.vue")
  },
  {
    path: "/password",
    name: "ResetPassword",
    component: () => import("../views/mobile/auth/Password.vue")
  }
]

export const desktopRoutes = [
  ...authRoutes,
  { path: "/home", component: () => import("@/views/mobile/home/Home.vue") },
  { path: "/admin", component: () => import("@/views/mobile/admin/Admin.vue") },
  { path: "/userSetting", component: () => import("@/views/mobile/userSetting/userSetting.vue") },
  { path: "/account", component: () => import("@/views/mobile/admin/account/Account.vue") },
  { path: "/ecat", component: () => import("@/views/mobile/admin/ecat/Ecat.vue") },
  { path: "/customized", component: () => import("@/views/mobile/admin/ecat/CustomizedDetails.vue") },
  { path: "/feedback", component: () => import("@/views/mobile/admin/feedback/Feedback.vue") },
  { path: "/my", component: () => import("@/views/mobile/My/My.vue") },
  { path: "/about", component: () => import("@/views/mobile/My/about/About.vue") },
  { path: "/nomenclature", component: () => import("@/views/mobile/My/nomenclature/Nomenclature.vue") },
  { path: "/dashboard", component: () => import("@/views/mobile/dashboard/Dashboard.vue") },
  { path: "/usefultools", component: () => import("@/views/mobile/My/usefulTools/UsefulTools.vue") },

  {
    path: "/project",
    component: () => import("@/views/mobile/project/Project.vue"),
    children: [
      {
        path: "objective",
        component: () => import("@/views/mobile/project/objective/Objective.vue")
      },
      { ...baseline },
      { ...proposed }
    ]
  },

  {
    path: "/wizard",
    component: () => import("@/views/mobile/wizard/Wizard.vue"),
    children: [
      // {
      // 	path: "objective",
      // 	component: () => import("@/views/mobile/wizard/objective/Objective.vue")
      // },
      { ...wizardDetails }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/desktop.js